import { deepClone } from "@/utils";

export const setRule = (obj?: object) =>
  ({
    ...obj,
  } as { [key: string]: string });

export const setOrderedRule = (
  rule: any,
  orderedKeys: string[]
) => {
    const actualRule = rule.hasOwnProperty("0") ? rule["0"] : rule;
  return Object.assign({}, ...orderedKeys.map((key) => ({ [key]: rule[key] })));
};

export const getChildOutputHeader = <T>(rule: T) => {
  return Object.entries(rule)
    .filter(([key]) => !key.toLowerCase().includes("toggle"))
    .map(([key], index: number) => ({
      label: `Output Header ${index + 1}`,
      externalId: `oh-${key}-businessRuleId`,
      defaultValue: "",
      businessRuleResultType: key,
    }));
};

export const getChildBusinessRuleResult = <T>(rule: T, briIndex: number) => {
  return Object.entries(rule)
    .filter(([key]) => !key.toLowerCase().includes("toggle"))
    .map(([key, value]) => ({
      result:
        value === null || value === "" || value === undefined
          ? "return 'null'"
          : `return '${value}'`,
      externalId: `bris-${key}-bri-${briIndex}-businessRuleId`,
      outputHeader: {
        label: null,
        externalId: `oh-${key}-businessRuleId`,
        defaultValue: null,
        businessRuleResultType: null,
      },
    }));
};

export const rulePayload = (params: {
  inputAttribute: string;
  inputDataType: string;
  orderedRule: { [p: string]: string };
}) => {
  const { inputAttribute, inputDataType, orderedRule } = params;
  const childInputHeader = {
    label: "Input Header 1",
    dataType: inputDataType,
    attribute: inputAttribute,
    externalId: "ih-inputHeader1AssessmentKey1-businessRuleId",
    defaultValue: "",
    assessmentKey: "inputHeader1AssessmentKey1",
  };
  const childOutputHeader = getChildOutputHeader(orderedRule);
  const childBusinessRuleItem = [
    {
      externalId: "bri-1-businessRuleId",
      evaluationOrder: 1,
      childBusinessRuleResult: getChildBusinessRuleResult(orderedRule, 1),
      childBusinessRuleAssessment: [
        {
          rule: "return true",
          externalId: "bria-inputHeader1AssessmentKey1-bri-1-businessRuleId",
          inputHeader: {
            label: null,
            dataType: null,
            attribute: null,
            externalId: "ih-inputHeader1AssessmentKey1-businessRuleId",
            defaultValue: null,
            assessmentKey: null,
          },
        },
      ],
    },
  ];

  return {
    label: "BusinessRule1",
    externalId: "businessRuleId",
    failIfNoResult: false,
    childInputHeader: [childInputHeader],
    childOutputHeader: childOutputHeader,
    childBusinessRuleItem: childBusinessRuleItem,
    returnMultipleResults: false,
  };
};

export const extract = (rule: any, results: any) => {
  const advancedResults: any = [];
  rule.childBusinessRuleItem.forEach((item: any) => {
    let mock = deepClone(results);
    item.childBusinessRuleResult.forEach((businessRuleResult: any) => {
      const outputHeaderId = businessRuleResult.outputHeader.externalId;
      const result = businessRuleResult.result;



      // Keep regex parsing while avoiding broad ambiguous capture patterns.
      const resultMatch = result.match(/^return\s+([^\r\n]*)$/);
      const normalizedResult =
        resultMatch &&
        resultMatch[1].length >= 2 &&
        resultMatch[1].startsWith("'") &&
        resultMatch[1].endsWith("'")
          ? resultMatch[1].slice(1, -1)
          : resultMatch?.[1];
      let outputHeaderIdMatch = outputHeaderId.match(
        /^oh-(\w+)-businessRuleId$/
      );
      if(!outputHeaderIdMatch){
        outputHeaderIdMatch  =outputHeaderId.match(/^oh-Output-Header-(\w+)-businessRuleId$/)
      }
      if (resultMatch && outputHeaderIdMatch) {
        const extractBusinessRuleResult =
          normalizedResult === "null" ? null : normalizedResult;
        const extractBusinessRuleType = outputHeaderIdMatch[1];

        mock[extractBusinessRuleType] = extractBusinessRuleResult || "";
      }
    });
    advancedResults.push(mock);
    mock = results;
  });

  return advancedResults;
};
